<div [@routerTransition] class="d-flex flex-column flex-root">
    <mazars-header
        [useBurgerMenu]="true"
        [actionsTemplate]="actionsTemplate"
        (toggle)="toggleMenu($event)"
        [toolHeaderIcon]="selectedAppMenuItem?.icon"
        [toolHeaderTitle]="l(selectedAppMenuItem?.name)"
        [uid]="'root-mazars-header'"
    ></mazars-header>
    <ng-template #actionsTemplate>
        <active-delegated-users-combo *ngIf="!installationMode"></active-delegated-users-combo>
        <subscription-notification-bar></subscription-notification-bar>
        <quick-theme-selection></quick-theme-selection>
        <mazars-language-dropdown></mazars-language-dropdown>
        <header-notifications></header-notifications>
        <chat-toggle-button></chat-toggle-button>
        <user-menu [togglerCssClass]="''"></user-menu>
    </ng-template>

    <!-- container underneath header -->
    <div class="layout-container">
        <!-- menu -->

        <div class="layout-menu">
            <div
                *ngIf="currentTheme.baseSettings.menu.allowAsideMinimizing"
                class="side-bar-toggle-btn d-none btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
                [ngClass]="isSidebarToggled ? 'side-bar-toggle-btn--toggled' : ''"
                (click)="toggleSideBar()"
            >
                <span class="svg-icon svg-icon-1" [ngClass]="isSidebarToggled ? 'rotate-180' : 'rotate-360'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            opacity="0.5"
                            d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z"
                            fill="black"
                        ></path>
                        <path
                            d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z"
                            fill="black"
                        ></path>
                    </svg>
                </span>
            </div>

            <div
                [ngClass]="isBurgermenuOpen ? 'aside--checked' : ''"
                [ngClass]="isSidebarToggled ? 'aside--toggled' : ''"
                class="aside aside-{{ currentTheme.baseSettings.menu.asideSkin }} aside-hoverable"
            >
                <div class="aside-menu flex-column-fluid h-100">
                    <div class="hover-scroll-overlay-y h-100">
                        <side-bar-menu
                            [menuClass]="
                                'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500'
                            "
                        ></side-bar-menu>
                    </div>
                </div>
            </div>
        </div>
        <!-- inner container-->
        <div class="layout-inner-container">
            <!-- main content -->
            <main class="layout-main">
                <router-outlet></router-outlet>
            </main>

            <!-- footer -->
            <footer class="layout-footer">
                <footer-bar></footer-bar>
            </footer>
        </div>
    </div>
</div>
